module.exports = __webpack_public_path__ + "media/mosaics/Mosaics-Keepsake-c42fdd06.jpg";